/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const statuses = ["NOTASSIGNED", "PRELIMINARY", "FINAL", "TERMINATED"];
export const deviceTypes = [
  "PACEMAKER",
  "CRTP",
  "ICD",
  "CRTD",
  "ILR",
  "IPG",
  "PPM",
  "MONITOR",
  "ICM",
  "MCT",
  "EVENT",
  "HOLTER",
  "BGM",
  "BP_CUFF",
  "WEIGHTSCALE",
  "OTHER",
];
export const deviceManufacturers = ["BIOTRONIK", "BOSTONSCI", "MEDTRONIC", "STJUDE", "BIOTEL", "OTHER"];
export const thirtyDayStatuses = ["BILLABLE", "INTERIM", "NOTENABLED"];
export const interrogationTypes = ["REMOTE", "POC"];
export const insuranceTypes = ["MEDICARE", "PRIVATE", "HMO", "PPO", "FFS", "CAPITATED", "OTHER", "SELFPAY"];
export const interrogationAccessHistories = ["TODAY", "YESTERDAY"];
export const calibrationOptions = [
  { info: "Search by Auto Calibration...", value: "" },
  { info: "YES", value: true },
  { info: "NO", value: false },
];
export const mfrAlertOptions = ["Search by MFR Alert...", "YES", "NO"];
